import React from "react";
import { Row, Col, Button, Modal} from "antd";
import ChangePasswordModal from "components/settings/ChangePasswordModal";
import EnterOTPLayout from "components/EnterOTPLayout";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import FieldCountryWithFlag from "components/general/FieldCountryWithFlag";
import { getCountryCodeByLabel } from "utils/utils";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class SetupPaymentTab extends React.Component {

  state = {
    showChangePasswordModal: false,
    showOTPModal: false
  };

  showChangePasswordModal = e => {
    this.setState({ showChangePasswordModal: true });
  };

  hideChangePasswordModal = e => {
    this.setState({ showChangePasswordModal: false });
  };
  render() {
    const { profile } = this.props;
    const intl = this.props.useIntl;

    const countryCode =
      (profile.country && getCountryCodeByLabel(profile.country)) || "";
    return (
      <div className="content-wrapper">
        <div className="banner">
          <FormattedMessage id="app.message.companyprofile.cannotchangecompanyprofile"/>
          <a href="mailto:operations@brdgx.com">operations@brdgx.com</a>
        </div>

        <h6 className={"fw-600"}><FormattedMessage id="app.page.companyprofile.companydetails"/></h6>
        <div className="profile-page-body">
          <div className="bp-bordered-panel bp-margin-top-smallest-2">
            <Row gutter={24}>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.page.companyprofile.referenceid"})}
                  value={profile.referenceNumber || ""}
                />
              </Col>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.page.companyprofile.companyname"})}
                  value={profile.corporateAccountDetails.nameOfBusiness || ""}
                />
              </Col>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                    className="bp-table-cell"
                    title={intl.formatMessage({id: "app.page.companyprofile.businessemail"})}
                    value={profile.email || ""}
                />
              </Col>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                    className="bp-table-cell"
                    title={intl.formatMessage({id: "app.page.companyprofile.country"})}
                    value={profile.corporateAccountDetails.countryName || ""}
                />
              </Col>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.page.companyprofile.registrationnumber"})}
                  value={profile.corporateAccountDetails.businessRegistrationNumber || ""}
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.page.companyprofile.addressline1"})}
                  value={profile.corporateAccountDetails.addressLine1 || ""}
                />
              </Col>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.page.companyprofile.addressline2"})}
                  value={profile.corporateAccountDetails.addressLine2 || ""}
                />
              </Col>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.page.companyprofile.postalcode"})}
                  value={profile.corporateAccountDetails.postalCode || ""}
                />
              </Col>
              <Col md={6} sm={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.page.companyprofile.tradingaddress"})}
                  value={profile.corporateAccountDetails.tradingAddress || ""}
                />
              </Col>
            </Row>
            <Row gutter={24}>
              
            </Row>
          </div>
          <h6 className={"fw-600"}><FormattedMessage id="app.page.companyprofile.changepassword"/></h6>
          <div className="bp-bordered-panel">
              <Row>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title={intl.formatMessage({id: "app.page.companyprofile.currentpassword"})}
                    value="************"
                  />
                </Col>
                <Col md={6} sm={12}>
                  <div className="change-button">
                    <Button
                      type="primary"
                      onClick={this.showChangePasswordModal}
                      htmlType={"button"}>
                      <FormattedMessage id="app.page.companyprofile.changepassword"/>
                    </Button>
                  </div>
                </Col>
              </Row>
              <ChangePasswordModal
                visible={this.state.showChangePasswordModal}
                onOk={this.props.onChangePassword}
                onCancel={this.hideChangePasswordModal}
              />
              <Modal
                wrapClassName="otp-sign-in"
                visible={this.props.showOTPModal}
                closable={false}
                footer={null}
              >
                <EnterOTPLayout verifyOTP={this.props.onSubmitOTP}  customer={this.props.profile} />
              </Modal>
            </div>
        </div>
      </div>
    );
  }
}

export default withUseIntl(SetupPaymentTab);